import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* Router Modules */
import accountRouter from './modules/account'
import h7Router from './modules/h7'

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/register',
    component: () => import('@/views/register/index'),
    hidden: true
  },
  {
    path: '/forgot',
    component: () => import('@/views/forgot/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/dashboard/index'),
        name: 'Dashboard',
        hidden: true,
        meta: { title: 'menu.dashboard', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/profile',
    component: Layout,
    redirect: '/profile/index',
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/profile/index'),
        name: 'Profile',
        meta: { title: 'Profile', icon: 'user', noCache: true }
      }
    ]
  }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  /** when your routing map is too long, you can split it into small modules **/
  h7Router,
  accountRouter,
  {
    path: '/enterprise',
    component: Layout,
    meta: { title: 'Enterprise', icon: 'documentation' },
    children: [
      {
        path: 'filing',
        component: () => import('@/views/enterprise/index'),
        name: 'Enterprise',
        meta: { title: 'Enterprise' }
      }
    ]
  },
  {
    path: '/enterprise-check',
    component: Layout,
    meta: { icon: 'documentation' },
    children: [
      {
        path: 'list',
        component: () => import('@/views/enterprise/list'),
        name: 'Enterprise-list',
        meta: { title: 'Enterprise filling review' }
      },
      {
        path: 'detail',
        component: () => import('@/views/enterprise/detail'),
        name: 'Enterprise-review',
        hidden: true,
        meta: { title: 'Enterprise filling detail', noCache: true, activeMenu: '/enterprise-check/list' }
      }
    ]
  },
  {
    path: '/menu',
    component: Layout,
    meta: { icon: 'documentation' },
    children: [
      {
        path: 'edit',
        component: () => import('@/views/menu/index'),
        name: 'menu.name.memuManagement',
        meta: { title: 'menu.name.memuManagement' }
      }
    ]
  },
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
